/**
 * @generated SignedSource<<e4eaaae50d5ab7f1e904fe6a15b02a62>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type PersistenceState = "PENDING" | "SAVED" | "UPLOADING" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ItemViewer_node$data = {
  readonly __typename: string;
  readonly canRename?: {
    readonly value: boolean;
  };
  readonly canUpdate?: {
    readonly value: boolean;
  };
  readonly content?: {
    readonly __typename: "ExternalBridge";
    readonly id?: string;
    readonly url?: URIString;
  } | {
    readonly __typename: "File";
    readonly fileName?: string;
    readonly id: string;
    readonly mimeType?: string;
    readonly name?: string;
    readonly persistenceState: PersistenceState;
    readonly size?: number;
    readonly url?: URIString;
  } | {
    readonly __typename: "Form";
    readonly id?: string;
  } | {
    readonly __typename: "InternalBridge";
    readonly id?: string;
    readonly url?: URIString;
  } | {
    readonly __typename: "Page";
    readonly data?: UnknownJSON | null;
    readonly id?: string;
  } | {
    readonly __typename: "PendingFile";
    readonly __typename?: "PendingFile";
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
  readonly draftContent?: {
    readonly __typename: "File";
    readonly id: string;
    readonly persistenceState: PersistenceState;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
  readonly id: string;
  readonly name?: string;
  readonly parent?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id?: string;
      } | null;
    }>;
  };
  readonly " $fragmentSpreads": FragmentRefs<"BridgeViewer_node" | "FileRenderer_node" | "FormViewer_node" | "ItemMenu_node" | "ItemOpenedTracker_item" | "PageEditor_node">;
  readonly " $fragmentType": "ItemViewer_node";
};
export type ItemViewer_node$key = {
  readonly " $data"?: ItemViewer_node$data;
  readonly " $fragmentSpreads": FragmentRefs<"ItemViewer_node">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "persistenceState",
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    (v0/*: any*/),
    (v2/*: any*/)
  ],
  "type": "File",
  "abstractKey": null
},
v4 = [
  (v1/*: any*/),
  (v3/*: any*/)
],
v5 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "content",
  "plural": false,
  "selections": (v4/*: any*/),
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v8 = [
  (v0/*: any*/)
],
v9 = [
  (v0/*: any*/),
  (v7/*: any*/)
],
v10 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "value",
    "storageKey": null
  }
],
v11 = [
  (v6/*: any*/),
  (v5/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ItemViewer_node",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FileRenderer_node"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PageEditor_node"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ItemOpenedTracker_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FormViewer_node"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ItemMenu_node"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BridgeViewer_node"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v5/*: any*/)
      ],
      "type": "AnnouncementAttachment",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "content",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                (v0/*: any*/),
                (v6/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "fileName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "mimeType",
                  "storageKey": null
                },
                (v7/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "size",
                  "storageKey": null
                },
                (v2/*: any*/)
              ],
              "type": "File",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "MemberDetailsAttachment",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v6/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "content",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "data",
                  "storageKey": null
                }
              ],
              "type": "Page",
              "abstractKey": null
            },
            (v3/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": (v8/*: any*/),
              "type": "Form",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v9/*: any*/),
              "type": "InternalBridge",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v9/*: any*/),
              "type": "ExternalBridge",
              "abstractKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AuthorizationResult",
          "kind": "LinkedField",
          "name": "canRename",
          "plural": false,
          "selections": (v10/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AuthorizationResult",
          "kind": "LinkedField",
          "name": "canUpdate",
          "plural": false,
          "selections": (v10/*: any*/),
          "storageKey": null
        },
        {
          "alias": "parent",
          "args": [
            {
              "kind": "Literal",
              "name": "depth",
              "value": 1
            }
          ],
          "concreteType": "FolderNodeConnection",
          "kind": "LinkedField",
          "name": "ancestors",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "FolderNodeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": (v8/*: any*/),
                      "type": "Folder",
                      "abstractKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "ancestors(depth:1)"
        }
      ],
      "type": "FolderItem",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v11/*: any*/),
      "type": "VaultItem",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v11/*: any*/),
      "type": "PrivateVaultItem",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v6/*: any*/),
        {
          "alias": "draftContent",
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "content",
          "plural": false,
          "selections": (v4/*: any*/),
          "storageKey": null
        }
      ],
      "type": "VaultDraftItem",
      "abstractKey": null
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
})();

(node as any).hash = "0bea4ddf7b162a86f190ac82bad0538a";

export default node;
